import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { SupportReport } from '@nucleus-commerce/api-client/admin';
import { Button } from '@nucleus-commerce/ui/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@nucleus-commerce/ui/components/dropdown-menu';

import { saveFile } from '@/shared/browser/save-file';

import { supportCsv, supportCsvFilename, type SupportCsvKind } from '../schemas/support-csv';

const KINDS: readonly SupportCsvKind[] = ['daily', 'agents', 'tags'];

/** CSV of what the page shows, built in the browser; nothing is queued on the server. */
export function SupportExportMenu({ report }: { report: SupportReport | undefined }) {
  const { t } = useTranslation('reports');

  const download = (kind: SupportCsvKind) => {
    if (!report) return;
    saveFile(
      supportCsvFilename(report, kind),
      new Blob([supportCsv(report, kind)], { type: 'text/csv;charset=utf-8' }),
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={!report}>
          <Download aria-hidden />
          {t('support.export.button')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {KINDS.map((kind) => (
          <DropdownMenuItem key={kind} onSelect={() => download(kind)}>
            {t(`support.export.${kind}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
